import { fetchConToken } from '../helpers/fetch';
import { openModal, openModalBottom } from './ui';
import { detectarDispositivo } from '../helpers/deviceDetector';

export const iniciarJornada = (profesional, password, empresa) => {
    return async (dispatch) => {
        try {
            const dispositivo = detectarDispositivo();
            const resp = await fetchConToken('control-horario/iniciar', {
                profesional,
                password,
                empresa,
                dispositivo
            }, 'POST');
            
            const body = await resp.json();
            
            if (body.ok) {
                const datos = {
                    text: ['Jornada iniciada correctamente'],
                    timeOut: 3
                };
                dispatch(openModalBottom(datos));
                return { ok: true, estado: body.estado, controlHorario: body.controlHorario };
            } else {
                const datos = {
                    title: 'Error',
                    text: [body.msg || 'Error al iniciar la jornada'],
                    buttonText: 'Cerrar'
                };
                dispatch(openModal(datos));
                return { ok: false, msg: body.msg };
            }
        } catch (error) {
            console.log('Error al iniciar jornada:', error);
            const datos = {
                title: 'Error',
                text: ['Ha habido un error al iniciar la jornada'],
                buttonText: 'Cerrar'
            };
            dispatch(openModal(datos));
            return { ok: false, msg: 'Error de conexión' };
        }
    };
};

export const pausarJornada = (profesional, password, empresa) => {
    return async (dispatch) => {
        try {
            const dispositivo = detectarDispositivo();
            const resp = await fetchConToken('control-horario/pausar', {
                profesional,
                password,
                empresa,
                dispositivo
            }, 'POST');
            
            const body = await resp.json();
            
            if (body.ok) {
                const datos = {
                    text: ['Jornada pausada correctamente'],
                    timeOut: 3
                };
                dispatch(openModalBottom(datos));
                return { ok: true, estado: body.estado, controlHorario: body.controlHorario };
            } else {
                const datos = {
                    title: 'Error',
                    text: [body.msg || 'Error al pausar la jornada'],
                    buttonText: 'Cerrar'
                };
                dispatch(openModal(datos));
                return { ok: false, msg: body.msg };
            }
        } catch (error) {
            console.log('Error al pausar jornada:', error);
            const datos = {
                title: 'Error',
                text: ['Ha habido un error al pausar la jornada'],
                buttonText: 'Cerrar'
            };
            dispatch(openModal(datos));
            return { ok: false, msg: 'Error de conexión' };
        }
    };
};

export const reanudarJornada = (profesional, password, empresa) => {
    return async (dispatch) => {
        try {
            const dispositivo = detectarDispositivo();
            const resp = await fetchConToken('control-horario/reanudar', {
                profesional,
                password,
                empresa,
                dispositivo
            }, 'POST');
            
            const body = await resp.json();
            
            if (body.ok) {
                const datos = {
                    text: ['Jornada reanudada correctamente'],
                    timeOut: 3
                };
                dispatch(openModalBottom(datos));
                return { ok: true, estado: body.estado, controlHorario: body.controlHorario };
            } else {
                const datos = {
                    title: 'Error',
                    text: [body.msg || 'Error al reanudar la jornada'],
                    buttonText: 'Cerrar'
                };
                dispatch(openModal(datos));
                return { ok: false, msg: body.msg };
            }
        } catch (error) {
            console.log('Error al reanudar jornada:', error);
            const datos = {
                title: 'Error',
                text: ['Ha habido un error al reanudar la jornada'],
                buttonText: 'Cerrar'
            };
            dispatch(openModal(datos));
            return { ok: false, msg: 'Error de conexión' };
        }
    };
};

export const finalizarJornada = (profesional, password, empresa) => {
    return async (dispatch) => {
        try {
            const dispositivo = detectarDispositivo();
            const resp = await fetchConToken('control-horario/finalizar', {
                profesional,
                password,
                empresa,
                dispositivo
            }, 'POST');
            
            const body = await resp.json();
            
            if (body.ok) {
                const datos = {
                    text: ['Jornada finalizada correctamente'],
                    timeOut: 3
                };
                dispatch(openModalBottom(datos));
                return { ok: true, estado: body.estado, controlHorario: body.controlHorario };
            } else {
                const datos = {
                    title: 'Error',
                    text: [body.msg || 'Error al finalizar la jornada'],
                    buttonText: 'Cerrar'
                };
                dispatch(openModal(datos));
                return { ok: false, msg: body.msg };
            }
        } catch (error) {
            console.log('Error al finalizar jornada:', error);
            const datos = {
                title: 'Error',
                text: ['Ha habido un error al finalizar la jornada'],
                buttonText: 'Cerrar'
            };
            dispatch(openModal(datos));
            return { ok: false, msg: 'Error de conexión' };
        }
    };
};

export const getEstadoJornada = (profesionalId, empresa) => {
    return async () => {
        try {
            const url = `control-horario/estado/${profesionalId}?empresa=${empresa}`;
            const resp = await fetchConToken(url, {}, 'GET');
            const body = await resp.json();
            
            if (body.ok) {
                return { 
                    ok: true, 
                    estado: body.estado, 
                    ultimaAccion: body.ultimaAccion,
                    tiempoTranscurrido: body.tiempoTranscurrido
                };
            } else {
                return { ok: false, msg: body.msg };
            }
        } catch (error) {
            console.log('Error al obtener estado de jornada:', error);
            return { ok: false, msg: 'Error de conexión' };
        }
    };
};

export const getHistorialJornadas = (profesionalId, empresa, fechaInicio = null, fechaFin = null, limite = null) => {
    return async () => {
        try {
            let url = `control-horario/historial/${profesionalId}?empresa=${empresa}`;
            if (fechaInicio && fechaFin) {
                url += `&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
            }
            if (limite) {
                url += `&limite=${limite}`;
            }
            const resp = await fetchConToken(url, {}, 'GET');
            const body = await resp.json();
            
            if (body.ok) {
                return { ok: true, jornadas: body.jornadas, totalJornadas: body.totalJornadas };
            } else {
                return { ok: false, msg: body.msg };
            }
        } catch (error) {
            console.log('Error al obtener historial de jornadas:', error);
            return { ok: false, msg: 'Error de conexión' };
        }
    };
};

export const eliminarRegistroControlHorario = (registroId, empresa) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(`control-horario/registro/${registroId}?empresa=${empresa}`, {}, 'DELETE');
            const body = await resp.json();
            
            if (body.ok) {
                const datos = {
                    text: ['Registro eliminado correctamente'],
                    timeOut: 3
                };
                dispatch(openModalBottom(datos));
                return { ok: true };
            } else {
                const datos = {
                    title: 'Error',
                    text: [body.msg || 'Error al eliminar el registro'],
                    buttonText: 'Cerrar'
                };
                dispatch(openModal(datos));
                return { ok: false, msg: body.msg };
            }
        } catch (error) {
            console.log('Error al eliminar registro:', error);
            const datos = {
                title: 'Error',
                text: ['Ha habido un error al eliminar el registro'],
                buttonText: 'Cerrar'
            };
            dispatch(openModal(datos));
            return { ok: false, msg: 'Error de conexión' };
        }
    };
};

